<template>
  <div v-if="$supports('dioWidget') && articles.length" :id="widget.id" class="rounded-none sm:rounded-md overflow-hidden">
    <div class="bg-[#080C25] flex justify-between p-4">
      <OIcon icon="dio-widget" svg-class="" />
      <a class="flex items-center" :href="widget.href">
        <p class="text-[#D0D9FF] text-md leading-18 tracking-tight font-normal mr-2">{{ $t('main.all') }}</p>
        <ORawIcon icon="right" width="18" height="18" svg-class="bg-[#D0D9FF] fill-[#080C25] rounded-full" />
      </a>
    </div>
    <div class="w-full flex flex-col bg-transparent sm:bg-white space-y-4 py-4 sm:p-4">
      <WidgetCard v-for="item in articles" :key="item._id" variant="horizontal" class="w-full" :article="item" />
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import WidgetCard from '~/modules/card/templates/homepage/WidgetCard';
import { OIcon, ORawIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    WidgetCard,
    OIcon,
    ORawIcon,
  },
  props: {
    data: {
      type: Object,
      default: {},
      required: true,
    },
  },
  setup(props) {
    const widget = computed(() => props.data);
    const articles = computed(() => widget.value.data);
    return { widget, articles };
  },
});
</script>
